module.exports = __webpack_public_path__ + "media/images/img_magazine2-c3503c517a4cef2d2cc8a5f9a199b51a.jpg";